import { JOIN_CALLOUT } from '../../content/site';

/**
 * "Join HyperX" text section (designer addition 2026-07-17): the popup
 * black frame — rounded box with pointed wing caps, same treatment as
 * CallToRise minus the heading/divider — holding two centered paragraphs,
 * the first bold. The design's frame is 1200 (max) × 210.
 *
 * Line breaks: the design's exact breaks are enforced with <br> from lg up
 * (where the vw-scaled type is guaranteed to fit them); below lg the copy
 * wraps naturally, per the mobile allowance.
 *
 * Placement is phase-specific and owned by HomePage — the section itself
 * is identical on every state.
 */
export function JoinCallout() {
  return (
    <div className="flex w-full items-center justify-center px-2 sm:px-5">
      <img
        src="/assets/images/ornaments/popup-end-1.svg"
        alt=""
        className="w-[clamp(1.5rem,2.8vw,3.36rem)] shrink-0"
      />
      <div className="flex w-full max-w-content flex-col items-center gap-5 rounded-[clamp(20px,2.1vw,40px)] bg-black px-5 py-[clamp(1.5rem,2.9vw,2.2rem)] shadow-[0px_0px_20px_0px_rgba(0,0,0,1)]">
        {JOIN_CALLOUT.paragraphs.map((p, i) => (
          <p
            key={i}
            className={`max-w-[56rem] text-center font-body leading-normal text-brand-white [font-size:clamp(1rem,1.67vw,1.25rem)] ${
              p.bold ? 'font-bold' : ''
            }`}
          >
            {p.lines.map((line, j) => (
              <span key={j}>
                {j > 0 && (
                  <>
                    {/* The design's break on desktop; a space when wrapping
                        naturally below lg. */}
                    <span className="lg:hidden"> </span>
                    <br className="hidden lg:inline" />
                  </>
                )}
                {line}
              </span>
            ))}
          </p>
        ))}
      </div>
      <img
        src="/assets/images/ornaments/popup-end-2.svg"
        alt=""
        className="w-[clamp(1.5rem,2.8vw,3.36rem)] shrink-0 rotate-180"
      />
    </div>
  );
}
